export enum ChangeControlDetailsLabels {
  priority = 'Priority',
  phase = 'Phase',
  eQMSScopes = 'eQMS Scope(s)',
  reason = 'Reason',
  creationDate = 'Creation Date',
  responsibleSubBU = 'Responsible Sub-BU',
  impact = 'Impact',
  targetCompletionDate = 'Target Completion Date',
  clientNotification = 'Client Notification/Approval Required?',
  category = 'Category',
  approvedtoImplementDate = 'Approved to Implement Date',
  riskAssessmentRequired = 'Risk Assessment Required?',
  changeRequestSource = 'Change Request Source',
  completionDate = 'Completion Date',
  currentState = 'Current State',
  futureState = 'Future State',
  rationale = 'Rationale',
  implementationOwner = 'Implementation Owner(s)',
  reviewers = 'Reviewer(s)',
  notifiedUsers = 'Notified User(s)',
  collaborators = 'Collaborator(s)',
  approvers = 'Approver(s)',
  internalClientContact = 'Internal Client Contact',
  verifiers = 'Verifier(s)',
}
